export enum EmailSendStatus {
  NONE = "NONE",
  VERIFIFICATION_REQUIRED = "VERIFICATION_REQUIRED",
  RECHARGE = "RECHARGE",
  EMAIL_SENT = "EMAIL_SENT",
  EMAIL_NOT_SENT = "EMAIL_NOT_SENT",
  UNAUTHORIZED = "UNAUTHORIZED",
  ERROR = "ERROR",
}
